import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#020B1A] via-[#061426] to-[#0A1E3F] text-white relative overflow-hidden">
      {/* Glowing Background Effects */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-20 w-64 h-64 bg-cyan-500/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-20 w-64 h-64 bg-blue-600/30 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Ready to Transform Your Cloud Infrastructure?
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
          Get a free cloud assessment from our AWS certified experts
        </p>
        <Link to="/contact">
          <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-medium px-10 py-6 text-lg transition-all duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.5)' }}>
            Schedule Free Consultation
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
